import api from '@/utils/api';

const state = {
    announcements: [],
    experiments: [],
    cohorts: [],
    experimentResults: [],
    kpis: [],
    events: [],
    conversions: [],
    derivedEvents: [],
    features: [],
    dashboards: [],
    educationPosts: [],
    storybooks: []
};

const mutations = {
    setStorybooks(state, data) {
        state.storybooks = data;
    },
    setExperiments(state, data) {
        state.experiments = data;
    },
    setCohorts(state, data) {
        state.cohorts = data;
    },
    setExperimentResults(state, data) {
        state.experimentResults = data;
    },
    setKpis(state, data) {
        state.kpis = data;
    },
    setEvents(state, data) {
        state.events = data;
    },
    setConversions(state, data) {
        state.conversions = data;
    },
    setDerivedEvents(state, data) {
        state.derivedEvents = data;
    },
    setFeatures(state, data) {
        state.features = data;
    },
    setDashboards(state, data) {
        state.dashboards = data;
    },
    setAnnouncements(state, data) {
        state.announcements = data;
    },
    setEducationPosts(state, data) {
        state.educationPosts = data;
    },
};

const actions = {
    async getStorybooks({ commit }) {
        commit('setLoading', 'storybooks');
        const { data } = await api.get('/product/storybooks', { params: { page_size: 20 } });
        commit('setStorybooks', data.results);
        commit('unsetLoading', 'storybooks');
    },
    async getExperiments({ commit }) {
        commit('setLoading', 'experiments');
        const { data } = await api.get('/product/experiments', { params: { page_size: 400 } });
        commit('setExperiments', data.results);
        commit('unsetLoading', 'experiments');
    },
    async getCohorts({ commit }) {
        commit('setLoading', 'cohorts');
        const { data } = await api.get('/product/cohorts');
        commit('setCohorts', data.results);
        commit('unsetLoading', 'cohorts');
    },
    async getExperimentResults({ commit }, datesRange = []) {
        commit('setLoading', 'experimentResults');
        const [start, end] = datesRange;
        const { data } = await api.get('/product/experiments/results', { params: { start, end } });
        commit('setExperimentResults', data.results);
        commit('unsetLoading', 'experimentResults');
    },
    async refreshExperimentsCohorts({ commit }) {
        commit('setLoading', 'experimentCohortsRefresh');
        await api.post('/product/experiments/refresh_all_cohorts');
        commit('unsetLoading', 'experimentCohortsRefresh');
    },
    async getKpis({ commit }) {
        commit('setLoading', 'kpis');
        const { data } = await api.get('/ada/kpi');
        commit('setKpis', data.results);
        commit('unsetLoading', 'kpis');
    },
    async getEvents({ commit }) {
        commit('setLoading', 'events');
        const { data } = await api.get('/ada/events');
        commit('setEvents', data.results);
        commit('unsetLoading', 'events');
    },
    async getKpiEvents({ commit }) {
        commit('setLoading', 'kpiEvents');
        const { data } = await api.get('/ada/kpi/events');
        commit('setConversions', data.results.conversion);
        commit('setDerivedEvents', data.results.derived_event);
        commit('unsetLoading', 'kpiEvents');
    },
    async getFeatures({ commit }) {
        commit('setLoading', 'features');
        const { data } = await api.get('/product/features');
        commit('setFeatures', data.results);
        commit('unsetLoading', 'features');
    },
    async getDashboards({ commit }) {
        commit('setLoading', 'dashboards');
        const { data } = await api.get('/dashboards');
        commit('setDashboards', data.results);
        commit('unsetLoading', 'dashboards');
    },
    async getAnnouncements({ commit }) {
        commit('setLoading', 'announcements');
        const { data } = await api.get('/product/announcements');
        commit('setAnnouncements', data.results);
        commit('unsetLoading', 'announcements');
    },
    async getEducationPosts({ commit }) {
        commit('setLoading', 'educationPosts');
        const { data } = await api.get('/product/education_posts');
        commit('setEducationPosts', data.results);
        commit('unsetLoading', 'educationPosts');
    }
};

const getters = {
    storybooks: s => s.storybooks,
    experiments: s => s.experiments,
    cohorts: s => s.cohorts,
    experimentResults: s => s.experimentResults,
    announcements: s => s.announcements,
    educationPosts: s => s.educationPosts,
    kpis: s => s.kpis,
    events: s => s.events,
    conversions: s => s.conversions,
    derivedEvents: s => s.derivedEvents,
    features: s => s.features,
    dashboards: s => s.dashboards,
};

export default {
    state,
    mutations,
    actions,
    getters,
};
